(function () {
  "use strict";

  var KB = [
    { k: ["livraison", "delai", "délai", "expedition", "expédition", "combien de temps", "quand je vais recevoir", "shipping", "recevoir ma commande"],
      a: "🚚 Livraison gratuite partout dans le monde ! Traitement de la commande sous 1 à 3 jours ouvrés, puis 7 à 15 jours de livraison selon ta destination." },
    { k: ["suivi", "tracking", "où est ma commande", "statut", "colis"],
      a: "📦 Dès l'expédition de ta commande, tu reçois un e-mail avec ton numéro de suivi. Si tu ne l'as pas reçu ou que ton colis semble en retard, écris-nous à businessbridgecompagny1@gmail.com avec ton numéro de commande." },
    { k: ["douane", "taxe", "frais suppl"],
      a: "Pour les commandes hors Union Européenne, des frais de douane/taxes locales peuvent s'appliquer à la livraison (à ta charge, non inclus dans le prix affiché)." },
    { k: ["retour", "rembours", "garantie", "satisfait", "annuler", "annulation"],
      a: "✅ Garantie 30 jours satisfait ou remboursé ! Si le produit ne te convient pas, écris-nous à businessbridgecompagny1@gmail.com avec ton numéro de commande dans les 30 jours suivant réception. Remboursement sous 5 à 10 jours ouvrés une fois le retour reçu et vérifié. Commande pas encore expédiée ? Tu peux l'annuler gratuitement." },
    { k: ["cryo wand", "cryo", "wand", "acier"],
      a: "❄️ Cryo Wand — 1) Congélateur 20-30 min (ou toute la nuit). 2) Applique un sérum/huile sur peau propre, puis glisse le wand du cou vers le haut/extérieur (mâchoire, pommettes, front, sous les yeux), 3-5 min. 3) Termine par ta crème hydratante. Convient à tous types de peau, y compris sensible." },
    { k: ["gua sha", "jade"],
      a: "🪨 Jade Roller & Gua Sha — 1) Applique une huile/sérum sur peau propre. 2) Rouleau de jade du centre vers l'extérieur/le haut (mâchoire, pommettes, yeux, front), 2-3 min. 3) Gua sha à plat contre la peau (angle 15-45°), mouvements fermes vers le haut/extérieur, en terminant par le cou pour le drainage." },
    { k: ["contour", "lift", "34,99", "34.99"],
      a: "🧊 Facial Ice Roller Contour, Lift & Glow — 1) Congélateur 15-20 min. 2) Roule du centre du visage vers l'extérieur/le haut (mâchoire, pommettes, contour des yeux, front), 60-90 secondes. 3) Applique ton sérum/crème juste après." },
    { k: ["cool & glow", "cool and glow", "24,99", "24.99", "cool glow"],
      a: "💧 Facial Ice Roller Cool & Glow — 1) Congélateur 15-20 min. 2) Roule sur le visage. 3) Profite du résultat immédiat (anti-poches, apaisant, effet réveillé). Le plus simple de la gamme, 60 secondes chrono." },
    { k: ["prix", "combien coute", "combien ça coûte", "tarif"],
      a: "💰 Nos prix : Cool & Glow 24,99 $ · Contour, Lift & Glow 34,99 $ · Jade Roller & Gua Sha 39,99 $ · Cryo Wand à partir de 49,99 $." },
    { k: ["promo", "reduction", "réduction", "code promo", "-50", "offre"],
      a: "🎁 En ce moment : le 2ᵉ LuxeIce Cool & Glow est à -50% ! Appliqué automatiquement au panier, pas de code nécessaire." },
    { k: ["sensible", "acne", "acné", "rosacee", "rosacée", "dermato"],
      a: "Oui, nos 4 produits conviennent aux peaux sensibles et acnéiques. En cas de pathologie cutanée spécifique, on te recommande d'en parler d'abord à ton dermatologue." },
    { k: ["paiement", "payer", "carte", "apple pay", "shop pay"],
      a: "💳 Paiement sécurisé via Shopify Payments : carte bancaire, Shop Pay, Apple Pay et autres moyens proposés au moment du règlement." },
    { k: ["contact", "email", "e-mail", "mail", "parler a quelqu'un", "humain", "sav"],
      a: "Tu peux nous écrire directement à businessbridgecompagny1@gmail.com, on te répond rapidement !" }
  ];

  var FALLBACK = "Je n'ai pas encore de réponse toute prête pour ça 🙂 Écris-nous directement à businessbridgecompagny1@gmail.com et on te répond vite, ou choisis une des questions ci-dessous !";
  var QUICK = ["Livraison", "Retours & garantie", "Comment utiliser mon produit", "Promo en cours", "Contact"];

  function match(text) {
    var t = text.toLowerCase();
    var answers = [];
    var used = {};
    for (var i = 0; i < KB.length; i++) {
      for (var j = 0; j < KB[i].k.length; j++) {
        if (t.indexOf(KB[i].k[j]) !== -1) {
          if (!used[i]) {
            used[i] = true;
            answers.push(KB[i].a);
          }
          break;
        }
      }
    }
    if (answers.length === 0) return null;
    // Limite à 3 réponses max pour rester lisible même si la question couvre beaucoup de sujets
    return answers.slice(0, 3).join("\n\n");
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var style = document.createElement("style");
    style.textContent =
      "#liz-bubble{position:fixed;bottom:20px;right:20px;width:60px;height:60px;border-radius:50%;background:#111;color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.25);z-index:99999;font-size:26px;}" +
      "#liz-panel{position:fixed;bottom:92px;right:20px;width:320px;max-width:90vw;height:420px;max-height:70vh;background:#fff;border-radius:14px;box-shadow:0 8px 32px rgba(0,0,0,.25);display:none;flex-direction:column;overflow:hidden;z-index:99999;font-family:inherit;}" +
      "#liz-panel.open{display:flex;}" +
      "#liz-head{background:#111;color:#fff;padding:14px 16px;font-weight:600;font-size:14px;}" +
      "#liz-msgs{flex:1;overflow-y:auto;padding:12px;background:#f7f5f3;display:flex;flex-direction:column;gap:8px;}" +
      ".liz-msg{max-width:85%;padding:8px 12px;border-radius:12px;font-size:13px;line-height:1.4;white-space:pre-line;}" +
      ".liz-bot{background:#fff;border:1px solid #eee;align-self:flex-start;}" +
      ".liz-user{background:#111;color:#fff;align-self:flex-end;}" +
      "#liz-quick{display:flex;flex-wrap:wrap;gap:6px;padding:8px 12px;background:#fff;border-top:1px solid #eee;}" +
      ".liz-chip{border:1px solid #ddd;border-radius:14px;padding:5px 10px;font-size:11px;cursor:pointer;background:#fff;}" +
      "#liz-form{display:flex;border-top:1px solid #eee;}" +
      "#liz-input{flex:1;border:none;padding:12px;font-size:13px;outline:none;}" +
      "#liz-send{border:none;background:#111;color:#fff;padding:0 16px;cursor:pointer;font-size:13px;}";
    document.head.appendChild(style);

    var bubble = document.createElement("div");
    bubble.id = "liz-bubble";
    bubble.innerHTML = "💬";

    var panel = document.createElement("div");
    panel.id = "liz-panel";
    panel.innerHTML =
      '<div id="liz-head">Luxe Ice Beauty — pose ta question</div>' +
      '<div id="liz-msgs"></div>' +
      '<div id="liz-quick"></div>' +
      '<form id="liz-form"><input id="liz-input" type="text" placeholder="Écris ta question…" autocomplete="off"><button id="liz-send" type="submit">Envoyer</button></form>';

    document.body.appendChild(bubble);
    document.body.appendChild(panel);

    var msgs = panel.querySelector("#liz-msgs");
    var quick = panel.querySelector("#liz-quick");
    var form = panel.querySelector("#liz-form");
    var input = panel.querySelector("#liz-input");
    var opened = false;

    function addMsg(text, who) {
      var d = document.createElement("div");
      d.className = "liz-msg liz-" + who;
      d.textContent = text;
      msgs.appendChild(d);
      msgs.scrollTop = msgs.scrollHeight;
    }

    function respond(text) {
      addMsg(text, "user");
      setTimeout(function () {
        addMsg(match(text) || FALLBACK, "bot");
      }, 120);
    }

    QUICK.forEach(function (q) {
      var chip = document.createElement("div");
      chip.className = "liz-chip";
      chip.textContent = q;
      chip.addEventListener("click", function () { respond(q); });
      quick.appendChild(chip);
    });

    bubble.addEventListener("click", function () {
      opened = !opened;
      panel.classList.toggle("open", opened);
      if (opened && msgs.children.length === 0) {
        addMsg("Salut ! 👋 Je peux répondre tout de suite sur la livraison, les retours, l'utilisation de tes produits LuxeIce ou la promo en cours. Pose ta question ou choisis un sujet ci-dessous.", "bot");
      }
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = input.value.trim();
      if (!v) return;
      input.value = "";
      respond(v);
    });
  });
})();
